<template>
    <div class="tableDiv">
        <raw-data-table-base 
            :status-info="StatusInfo" 
            :table-id="tableId" 
            :api-info="ApiInfo" 
            :trial-id="TrialId" 
            :progeny-id="ProgenyId" 
            :palm-id="PalmId"
            :is-derived-data="isDerivedData"
            :export-info="exportInfo"
            @updateParam="$_updateTableParam($event)"
            @reloadTable="reloadTable()"
        >
            <template #TableTitle>
                <h4>Derived Bunch Data</h4>
            </template>
            <template v-if="isShowTable" #RawTable>
                <keep-alive>
                    <agrinome-table
                        :key="tableKey"
                        ref="agrinome-table"
                        :api-mode="true"
                        :columns="columns"
                        :selection-row.sync="selectionRow"
                        :http-options="httpOptions"
                        :api-url="apiUrl"
                        :append-params="appendParams"
                        @handle-sort="handleSort"
                        @handle-search="handleSearch"
                        @handle-edit="handleEdit"
                        @confirm-edit="confirmEdit"
                        @handle-delete="handleDelete"
                    />
                </keep-alive>
            </template>
        </raw-data-table-base>
    </div>
</template>

<script>
import BunchDerivedVariable from "@/assets/json/bunch-derived-variable.json";
import DataFlag from "@/components/DataFlag";

export default {
    props: ["PalmId", "TrialId", "ProgenyId"],
    data() {
        return {
            tableCode: "DERIVED",
            tableId: "#derivedBunchTable",

            TargetColumns: [],
            StartIndex: 5,

            FlagDialog: false,
            FlaggedData: [],

            StatusInfo: null,
            ApiInfo: {
                Table: "BunchData",
                UpdateManyKey: "bunchDataList",
                RepopulateMeanApi: "RepopulateBunchDerivedData"
            },

            isDerivedData: true,

            exportInfo: {
                exportUrl: "BunchData/ExportDerived",
                sortValue: "",
                searchValue: ""
            },

            appendParams: {
                PalmId: null,
                TrialId: null,
                ProgenyId: null,
                HasFailChecking: null,
                Status: null,
                RecordDateFrom: null,
                RecordDateTo: null,
                PalmNumber: null
            },

            pageLength: 10,

            columns: [
                {
                    name: "id",
                    label: "ID",
                    sortable: "custom",
                    width: "70",
                    isDisableEdit: true,
                },
                {
                    name: "palmTrialPalmNumber",
                    label: "Palm No",
                    sortable: "custom",
                    width: "105",
                    link: {
                        pageName: "PalmDetail",
                        linkId: "palmId"
                    }
                },
                {
                    name: "palmTrialPalmId",
                    label: "Palm ID",
                    sortable: "custom",
                    minWidth: "180",
                },
                ...this.getBunchDerivedVariableInTable(),
                {
                    name: "year",
                    label: "Year",
                    sortable: "custom",
                    width: "80",
                },
                {
                    name: "creationTime",
                    label: "Created At",
                    width: "170",
                    sortable: "custom",
                    formatter: this.$_getCreationTimeFormat(),
                    isDisableEdit: true
                },
                {
                    name: "",
                    label: "Condition Flag",
                    sortable: "custom",
                    width: 85,
                    customVueComponent: this.getDataFlaggedComponent(),
                    customVueComponentParams: {
                        "name": "bunchFlaggedDatas",
                    }
                },
                {
                    name: "status",
                    label: "Status",
                    sortable: "custom",
                    width: "85",
                    editOpts: [
                        { name: "OK", value: "OK" },
                        { name: "R", value: "R" },
                        { name: "KIV", value: "KIV" },
                        { name: "-", value: null },
                    ],
                    editOptId: "status",
                }
            ],
            
            selectionRow: [],
            apiUrl: "/api/services/app/BunchData/GetAll",
            httpOptions: ApiConfig.getHttpOption(),
            
            tableKey: 1,
            isShowTable: false
        };
    },
    mounted() {
        this.$nextTick(function() {
            this.appendParams.PalmId = this.PalmId;
            this.appendParams.TrialId = this.TrialId;
            this.appendParams.ProgenyId = this.ProgenyId;
            this.appendParams.isDerivedData = true;
            this.isShowTable = true;

            if (!this.PalmId && !this.TrialId && !this.ProgenyId) {
                this.pageLength = 25;
            }
        });
    },
    methods: {
        getDataFlaggedComponent() {
            return DataFlag;
        },
        getBunchDerivedVariableInTable() {
            return BunchDerivedVariable.map((item, index) => ({
                name: item.data,
                label: item.title,
                sortable: "custom",
                width: "85",
                formatter: this.$_getFixedDecimenPoint(3),
            }));
        },
        handleSort(sortValue) {
            this.exportInfo.sortValue = sortValue;
        },
        handleSearch(searchValue) {
            this.exportInfo.searchValue = searchValue;
        },
        handleEdit(index, row) {
            // this.getUsersDropdown();
        },
        confirmEdit(index, row) {
            this.$_confirmTableEdit(index, row, this.ApiInfo.Table);
        },
        handleDelete(index, row) {
            var self = this;
            DialogBus.$emit("open", {
                component: DeleteConfirmation,
                title: "Are you sure",
                props: { apiUrl: self.ApiInfo.Table + "/Delete", data: { id: row.id }, refs: "agrinome-table" },
                onSuccess: function onSuccess() {
                    self.tableKey++;
                }
            });
        },
        reloadTable() {
            this.$_reloadAgrinomeTable();
        }
    }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Palm/PalmDerivedData/DerivedBunchDataTable.vue